import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/frontend/components/common/ReduxProviderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/components/common/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/components/footer/FooterCompanyInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/components/header/DesktopMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/components/header/HeaderCompanyInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/components/header/LanguageSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/components/header/MobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/components/layout/AppState.tsx");
;
import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/frontend/xFrame4/components/common/SmoothImage.tsx");
;
import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/frontend/xFrame4/components/next/ALink.tsx");
